module.exports = __webpack_public_path__ + "static/img/cwy43.d29498b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwy43.png
// module id = cE5q
// module chunks = 73